import { fetchJSON, merge } from 'omni-ui';

const originsByEnv = {
  local: 'https://dev-api.sparksandhoney.com',
  dev: 'https://dev-api.sparksandhoney.com',
  qa: 'https://stage-api.sparksandhoney.com',
  stg: 'https://stage-api.sparksandhoney.com',
  prod: 'https://api.sparksandhoney.com',
};

class SparksHoneyAPI {
  constructor(token, env = 'prod') {
    this.model = 'gpt-4-32k';
    this.origin = originsByEnv[env];
    this.fetchOptions = {
      headers: {
        Authorization: token, // token already contains "Bearer"
      },
    };
  }

  createBody(payload) {
    return JSON.stringify({
      input_data: {
        ...payload,
        model: this.model,
      },
      // [sic] misspelling of usage in API
      ussage_request: {
        user_id: 1050013,
        frontend_url: '/ai',
        use_case: 'q_sparks',
      },
    });
  }

  async stepOne(payload) {
    const url = `${this.origin}/q_ai/spark_engine/step_one`;
    return fetchJSON(
      url,
      merge(this.fetchOptions, {
        method: 'POST',
        body: this.createBody(payload),
      }),
    );
  }

  async stepTwo(payload) {
    const url = `${this.origin}/q_ai/spark_engine/step_two`;
    return fetchJSON(
      url,
      merge(this.fetchOptions, {
        method: 'POST',
        body: this.createBody(payload),
      }),
    );
  }
}

export default SparksHoneyAPI;
